import { formatURIComponent, makeRecommends } from './utils'

export default (instance:string) => {

    const makeUrl = (path:string) => {
        return `/browser2?file_path=${formatURIComponent(path, instance)}&instance=${instance}`
    }

    return [{
        pageLayout: 'tabs',
        slogan: '华美服务 = 咨询服务 + 华美云 + 尽管问',
        pageTitle: '定位可研',
        pageTitleIcon: '',
        background_img: '/backgrounds/sunny.jpg',
        description: `华美的定位可研服务，包括市场分析、竞品评估及财务可行性研究，确保项目精准匹配市场需求。许多投资者因忽视市场饱和度、客群偏好或运营成本测算而导致决策失误。华美依托行业数据库与实战经验，提供兼具数据支撑与落地性的解决方案，帮助客户规避风险、提升回报。`,
        icons: [
            {
                name: '定位可研',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('/内容文件/华美/华美简介/1.定位可研.pdf'),
                path: "华美顾问/华美服务/定位可研/定位可研"
            },
            {
                name: '华美项目',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('华美项目'),
                path: "四库赋能-酒店建设/定位可研/华美项目"
            },
            {
                name: '数据赋能',
                img: '/icons/案例库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店建设/定位可研/数据赋能'),
                path: "四库赋能-酒店建设/定位可研/数据赋能"
            },
            {
                name: '全球案例',
                img: '/icons/案例库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店建设/定位可研/全球案例/全球案例（定位可研）.xlsx'),
                path: "四库赋能-酒店建设/定位可研/全球案例"
            },
            {
                name: '预警问题',
                img: '/icons/工具库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店建设/定位可研/预警问题/预警问题（定位可研）.xlsx'),
                path: "四库赋能-酒店建设/定位可研/预警问题"
            },
        ]
    }]
}